<template>
  <div>
    <div class="login_bg cloud-auth-bg"></div>
    <div class="content-box">
      <div class="login">
        <div v-if="pageMode === 'qr'" class="title">梦幻云平台</div>

        <div v-if="isResultMode" class="result-box">
          <i :class="resultIconClass"></i>
          <div class="result-title">{{ resultTitle }}</div>
          <div class="result-desc">{{ resultMessage }}</div>
          <button class="result-button" type="button" @click="handleResultAction">
            {{ resultButtonText }}
          </button>
        </div>

        <div v-else v-loading="loading" class="qr">
          <img
            :style="{ opacity: src ? '1' : '0' }"
            :class="[{ filter: status == 1 }]"
            :width="qrSize"
            :height="qrSize"
            :src="src"
            @load="qrLoaded"
            @error="qrError"
          />
          <div class="refresh" v-if="!loading && !isOk" @click="refresh">
            <i
              class="el-icon-refresh"
              :style="{ 'margin-top': qrSize / 2 - 40 + 'px' }"
            ></i>
            <div class="text">{{ errorMsg }}</div>
          </div>
          <div
            class="scan"
            v-if="!loading && isOk && status == 1"
            @click="confirmRefresh"
          >
            <i
              class="el-icon-circle-check"
              :style="{ 'margin-top': qrSize / 2 - 40 + 'px' }"
            ></i>
            <div class="text">您已扫码，请登录</div>
          </div>
        </div>

        <div v-if="pageMode === 'qr'" class="tishi">微信扫一扫，快速登录</div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Loading, MessageBox } from "element-ui";

Vue.use(Loading);

const PAGE_MODE_QR = "qr";
const PAGE_MODE_TERMINAL = "terminal";

const CHECK_INTERVAL_MS = 1700;
const CHECK_QR_MAX_FAIL_COUNT = 3;
const LAUNCH_SESSION_KEY_PREFIX = "open_authorize_launch:";

const DEFAULT_QR_ERROR_MESSAGE = "二维码加载失败，点击重试";
const QR_IMAGE_ERROR_MESSAGE = "二维码图片加载失败，点击重试";
const QR_EXPIRED_MESSAGE = "二维码已失效，点击重试";
const AUTH_INIT_FAILED_MESSAGE = "授权初始化失败";
const INVALID_APPID_MESSAGE = "AppID 参数错误";
const INVALID_REDIRECT_URI_MESSAGE = "redirect_uri 参数错误";
const TERMINAL_BUTTON_TEXT = "返回上一页";

export default {
  name: "login",
  data() {
    return {
      appid: null,
      redirect_uri: null,
      state: "",
      loading: true,
      isOk: false,
      qrSize: 180,
      status: -1,
      errorMsg: DEFAULT_QR_ERROR_MESSAGE,
      src: null,
      pollToken: "",
      timer: null,
      checkInterval: CHECK_INTERVAL_MS,
      checkQrFailCount: 0,
      checkQrMaxFailCount: CHECK_QR_MAX_FAIL_COUNT,
      isLogin: false,
      pageMode: PAGE_MODE_QR,
      resultTitle: "",
      resultMessage: "",
      resultButtonText: "",
    };
  },
  computed: {
    isResultMode() {
      return this.pageMode !== PAGE_MODE_QR;
    },
    resultIconClass() {
      return "el-icon-warning-outline result-icon danger";
    },
  },
  created() {
    this.appid = this.$route.query.appid;
    this.redirect_uri = this.$route.query.redirect_uri;
    this.state = this.$route.query.state;

    if (!this.appid) {
      this.showTerminalState("参数错误", INVALID_APPID_MESSAGE);
      return;
    }

    if (!this.redirect_uri) {
      this.showTerminalState("参数错误", INVALID_REDIRECT_URI_MESSAGE);
      return;
    }

    this.CreateQrCode();
  },
  beforeDestroy() {
    this.clearAllTimers();
  },
  methods: {
    qrLoaded() {
      this.loading = false;
      this.isOk = true;
      this.clearPollTimer();
      this.CheckQRCode();
    },
    qrError() {
      this.loading = false;
      this.isOk = false;
      this.errorMsg = QR_IMAGE_ERROR_MESSAGE;
      this.src = null;
    },
    refresh() {
      this.resetQrState();
      this.CreateQrCode();
    },
    confirmRefresh() {
      MessageBox.confirm(
        "刷新二维码后需要重新扫码，确定要刷新吗?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        this.refresh();
      });
    },
    clearPollTimer() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    },
    clearAllTimers() {
      this.clearPollTimer();
    },
    resetQrState() {
      this.clearAllTimers();
      this.pageMode = PAGE_MODE_QR;
      this.resultTitle = "";
      this.resultMessage = "";
      this.resultButtonText = "";
      this.pollToken = "";
      this.src = null;
      this.isOk = false;
      this.isLogin = false;
      this.status = -1;
      this.loading = false;
      this.checkQrFailCount = 0;
      this.errorMsg = DEFAULT_QR_ERROR_MESSAGE;
    },
    CreateQrCode() {
      this.resetQrState();
      this.loading = true;

      this.$http
        .post(
          "/Login/CreateQrSession",
          {
            app_id: this.appid,
            redirect_uri: this.redirect_uri,
            width: this.qrSize,
          },
          {
            withAuth: false,
            showErrorAlert: false,
          }
        )
        .then((data) => {
          this.pollToken = data.poll_token;
          this.src = data.qr_base64;
        })
        .catch((error) => {
          if (this.isBusinessRequestError(error)) {
            this.showTerminalState(
              AUTH_INIT_FAILED_MESSAGE,
              this.getRequestErrorMessage(error, AUTH_INIT_FAILED_MESSAGE)
            );
            return;
          }

          this.loading = false;
          this.isOk = false;
          this.src = null;
          this.errorMsg = DEFAULT_QR_ERROR_MESSAGE;
        });
    },
    scheduleCheckQRCode() {
      this.clearPollTimer();
      this.timer = setTimeout(() => {
        this.CheckQRCode();
      }, this.checkInterval);
    },
    showQrExpired(message = QR_EXPIRED_MESSAGE) {
      this.clearPollTimer();
      this.loading = false;
      this.isOk = false;
      this.pollToken = "";
      this.src = null;
      this.errorMsg = message;
    },
    CheckQRCode() {
      if (this.isLogin || !this.pollToken || this.isResultMode) {
        return;
      }

      this.$http
        .post(
          "/Login/CheckQRCode",
          {
            poll_token: this.pollToken,
          },
          {
            withAuth: false,
            showErrorAlert: false,
          }
        )
        .then((data) => {
          this.checkQrFailCount = 0;
          this.status = data.status;

          if (data.status == "-1") {
            this.showQrExpired();
          } else if (data.status == "2") {
            this.handleLoginSuccess(data.authorization_code);
          } else {
            this.scheduleCheckQRCode();
          }
        })
        .catch(() => {
          this.checkQrFailCount += 1;
          if (this.checkQrFailCount >= this.checkQrMaxFailCount) {
            this.showQrExpired();
            return;
          }

          this.scheduleCheckQRCode();
        });
    },
    handleLoginSuccess(authorizationCode) {
      const finalUrl = this.buildRedirectUrl(authorizationCode);

      this.isLogin = true;
      this.pollToken = "";
      this.src = null;
      this.clearAllTimers();

      if (this.isHttpRedirect(finalUrl)) {
        top.window.location.replace(finalUrl);
        return;
      }

      this.redirectToLaunchPage(finalUrl);
    },
    redirectToLaunchPage(finalUrl) {
      const launchToken = `${Date.now()}_${Math.random()
        .toString(36)
        .slice(2)}`;
      sessionStorage.setItem(
        `${LAUNCH_SESSION_KEY_PREFIX}${launchToken}`,
        JSON.stringify({
          url: finalUrl,
          createdAt: Date.now(),
        })
      );

      this.$router.replace({
        name: "SchemeLaunch",
        query: {
          launch_token: launchToken,
        },
      });
    },
    showTerminalState(title, message) {
      this.clearAllTimers();
      this.pageMode = PAGE_MODE_TERMINAL;
      this.loading = false;
      this.isOk = false;
      this.src = null;
      this.pollToken = "";
      this.resultTitle = title;
      this.resultMessage = message;
      this.resultButtonText = TERMINAL_BUTTON_TEXT;
    },
    buildRedirectUrl(authorizationCode) {
      const url = this.$appendParamToUrl(
        this.redirect_uri,
        "code",
        authorizationCode
      );
      return this.$appendParamToUrl(url, "state", this.state);
    },
    isHttpRedirect(url) {
      return /^https?:\/\//i.test(url);
    },
    getPreferredReturnUrl() {
      if (!document.referrer) {
        return "";
      }

      if (document.referrer === top.window.location.href) {
        return "";
      }

      return document.referrer;
    },
    goBackToPreviousPage() {
      const returnUrl = this.getPreferredReturnUrl();
      if (returnUrl) {
        top.window.location.replace(returnUrl);
        return;
      }

      if (top.window.history.length > 1) {
        top.window.history.back();
        return;
      }

      top.window.location.replace("/");
    },
    handleResultAction() {
      this.goBackToPreviousPage();
    },
    isBusinessRequestError(error) {
      return !!error?.rawError?.response;
    },
    getRequestErrorMessage(error, fallbackMessage) {
      const message =
        typeof error === "string"
          ? error
          : typeof error?.message === "string"
          ? error.message
          : "";

      if (
        !message ||
        message.indexOf("Cannot read properties of undefined") >= 0
      ) {
        return fallbackMessage;
      }

      return message;
    },
  },
};
</script>

<style>
.content-box {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  top: 0;
  margin-top: -55px;
}

.content-box .login {
  position: relative;
  background-color: rgba(255, 255, 255, 0.88);
  backdrop-filter: blur(14px);
  margin: 0;
  padding: 82px 50px;
  border: 1px solid rgba(255, 255, 255, 0.68);
  border-radius: 8px;
  min-width: 280px;
}

.content-box .qr {
  position: relative;
}

.content-box .title {
  position: absolute;
  top: 8px;
  left: 10px;
  font-size: 14px;
  color: #999999;
}

.content-box .tishi {
  font-size: 13px;
  padding-top: 14px;
  text-align: center;
  color: #2c3e50;
}

.content-box .refresh {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #333333;
  cursor: pointer;
  text-align: center;
}

.content-box .refresh .el-icon-refresh,
.content-box .scan .el-icon-circle-check {
  font-size: 52px;
  color: #fff;
}

.content-box .scan .el-icon-circle-check {
  font-size: 60px;
}

.content-box .refresh .text,
.content-box .scan .text {
  position: absolute;
  bottom: 30px;
  text-align: center;
  left: 0;
  right: 0;
  color: #fff;
  font-size: 12px;
}

.content-box .scan .text {
  bottom: 28px;
}

.content-box .scan {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #000000;
  opacity: 0.8;
  cursor: pointer;
  text-align: center;
}

.content-box .filter {
  filter: blur(2px);
}

.content-box .result-box {
  width: 230px;
  text-align: center;
}

.content-box .result-icon {
  font-size: 56px;
}

.content-box .result-icon.danger {
  color: #e6a23c;
}

.content-box .result-title {
  margin-top: 14px;
  font-size: 22px;
  color: #303133;
  font-weight: 600;
}

.content-box .result-desc {
  margin-top: 12px;
  font-size: 14px;
  color: #606266;
  line-height: 1.7;
}

.content-box .result-button {
  margin-top: 18px;
  min-width: 120px;
  height: 40px;
  border: none;
  border-radius: 4px;
  background: #409eff;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}

.content-box .result-button:hover {
  background: #66b1ff;
}
</style>
